export default {
  orderNumber: {
    notes: 'name of field "order number" for order',
    message: 'Order ID',
  },
  createdDate: {
    notes: 'Name of field "created date" for order',
    message: 'Created',
  },
  createdBy: {
    notes: 'Name of field "created by" for order',
    message: 'Creator',
  },
  emailRecipients: {
    notes: 'Name of field containing e-mail addresses',
    message: 'Confirmation e-mail address',
  },
  status: {
    notes: 'Name of field "created date" for order',
    message: 'Status',
    values: {
      submitted: {
        notes: 'Label for order status "submitted"',
        message: 'Submitted',
      },
      inProgress: {
        notes: 'Label for order status "in progress"',
        message: 'In progress',
      },
      complete: {
        notes: 'Label for order status "complete"',
        message: 'Complete',
      },
      cancelled: {
        notes: 'Label for order status "cancelled"',
        message: 'Cancelled',
      },
      unknown: {
        notes: 'Label for order status "unknown"',
        message: 'Unknown',
      },
    },
  },
  taggedTo: {
    notes: 'Name of field "tagged to" for order',
    message: 'Tagged to',
  },
  itemCount: {
    notes: 'Name of field "item count" for order',
    message: 'Items',
  },
  totalWeight: {
    notes: 'Name of field "total weight" for order',
    message: 'Total weight',
  },
  customerReference: {
    notes: 'Name of field "customer reference" for order',
    message: 'Customer reference',
  },
  backOrder: {
    notes: 'Name of field "back order" for order',
    message: 'Back order',
  },
  orderNotes: {
    notes: 'Name of field Notes (technically a "text" of type "external")',
    message: 'Notes',
  },
  subtotal: {
    notes: 'Name of field "subtotal" for order',
    message: 'Subtotal',
  },
  vat: {
    notes: 'Name of field "VAT" for order',
    message: 'VAT',
  },
  gst: {
    notes:
      'Name of field "GST" for order. Note! This is the Indian variant of VAT, and should probably be called GST in most (all?) languages!',
    message: 'GST',
  },
  grandTotal: {
    notes: 'Name of field "grand total" for order',
    message: 'Grand total',
  },
  invoiceLink: {
    notes: 'Name of field showing link to invoice for order',
    message: 'Invoice',
  },
  invoiceCount: {
    notes: 'Name of field showing invoice count for order',
    message: 'Number of invoices',
  },
  deliveryAddress: {
    notes: 'Name of field "delivery address" for order',
    message: 'Delivery address',
  },
  invoicingAddress: {
    notes: 'Name of field "invoicing address" for order',
    message: 'Invoicing address',
  },
  shipmentControl: {
    notes: 'Name of field "shipment control" for order',
    message: 'Shipment control',
    values: {
      partial: {
        notes: 'Display name of the partial option for delivery method',
        message: 'Partial',
        help: {
          notes: 'Help message describing delivery option partial',
          message:
            'Partial delivery means items will be shipped as soon as they become available',
        },
      },
      completeLine: {
        notes: 'Display name of the complete line option for delivery method',
        message: 'Hold line complete',
        help: {
          notes: 'Help message describing delivery option complete line',
          message:
            'Hold line complete means that items on a line will be shipped once all become available',
        },
      },
      complete: {
        notes: 'Display name of the complete option for delivery method',
        message: 'Hold order complete',
        help: {
          notes: 'Help message describing delivery option complete',
          message:
            'Hold order complete means that the order will be shipped once all items become available',
        },
      },
    },
  },
  typeInfo: {
    notes: 'Name of field "order type" for order',
    message: 'Type',
    values: {
      order: {
        notes: 'Display name for order type "order"',
        message: 'Order',
      },
      quotation: {
        notes: 'Display name for order type "quotation"',
        message: 'Quotation',
      },
    },
  },
  paymentMethod: {
    notes: 'Name of field "payment method" for order',
    message: 'Method',
  },
  criticality: {
    values: {
      normal: {
        notes: 'Label for "normal" order criticality',
        message: 'Normal - ships today if available and processed by 3:30pm',
      },
      stock: {
        notes: 'Label for "stock" order criticality',
        message: 'Stock - replenish Order',
      },
      emergency: {
        notes: 'Label for "unit down" order criticality',
        message: 'Unit Down Only will ship today if available',
      },
    },
  },
};
